// import nav1 from "@/assets/nav1.svg";
// import nav2 from "@/assets/nav2.svg";
// import nav3 from "@/assets/nav3.svg";
// import nav4 from "@/assets/nav4.svg";
// import nav5 from "@/assets/nav5.svg";
// import nav6 from "@/assets/nav6.svg";
// import nav7 from "@/assets/nav7.svg";

export default [{
    module_id: 3,
    module_name: "系统",
    icon: "el-icon-s-custom",
    index: "1",
    list: [
        {
            module_id: 39,
            module_name: "用户组权限",
            path: "/platform/permissions"
        }, {
            module_id: 31,
            module_name: "用户",
            path: "/platform/user"
        },
        {
            module_id: 32,
            module_name: "角色",
            path: "/platform/role"
        }, {
            module_id: 39,
            module_name: "售后",
            path: "/platform/workers"
        },
        // {
        //     module_id: 34,
        //     module_name: "代理商用户管理",
        //     path: "/platform/operatorUser"
        // },
        // {
        //     module_id: 35,
        //     module_name: "药房管理",
        //     path: "/platform/drug"
        // },

    ]
}, {
    module_id: 2,
    module_name: "系统字典",
    icon: "el-icon-film",
    index: "2",
    list: [
        {
            module_id: 21,
            module_name: "机构",
            path: "/platform/medicalInstitution"
        },
        {
            module_id: 22,
            module_name: "厂家",
            path: "/platform/manufacturer"
        },
        {
            module_id: 23,
            module_name: "地区",
            path: "/platform/region"
        },
        {
            module_id: 24,
            module_name: "药品类型",
            path: "/platform/remedy"
        }, {
            module_id: 25,
            module_name: "药品信息",
            path: "/platform/drugInfo"
        },
        {
            module_id: 26,
            module_name: "药杯型号",
            path: "/platform/drugCup"
        },
        {
            module_id: 27,
            module_name: "设备型号",
            path: "/platform/deviceType"
        },
        {
            module_id: 28,
            module_name: "异常类型",
            path: "/platform/exceptionRecord"
        },
        {
            module_id: 29,
            module_name: "保养类型",
            path: "/platform/maintenanceTypes"
        },
        {
            module_id: 30,
            module_name: "零件类型",
            path: "/platform/parttypes"
        },
        {
            module_id: 31,
            module_name: "区域售后负责人",
            path: "/platform/areamanager"
        }
        //     {
        //     module_id: 44,
        //     module_name: "药品消耗预警管理",
        //     path: "/platform/drugSafeRemianConfig"
        // },
        //{
        //     module_id: 57,
        //     module_name: "设备维护方案管理",
        //     path: "/platform/exceptionRecord"
        // },
    ]
},
    {
        module_id: 3,
        module_name: "服务器及数据库",
        icon: "el-icon-film",
        index: "3",
        list: [
            {
                module_id: 31,
                module_name: "服务器",
                path: "/platform/server"
            }, {
                module_id: 32,
                module_name: "数据库",
                path: "/platform/database"
            }, {
                module_id: 33,
                module_name: "药房数据库",
                path: "/platform/drugData"
            },
        ]
    },
    {
        module_id: 4,
        icon: "el-icon-s-platform",
        index: "4",
        module_name: "设备",
        path: "/platform/operator",
        list: [
            {
                module_id: 41,
                module_name: "现有设备",
                path: "/platform/equipment"
            }, {
                module_id: 42,
                module_name: "保养模板",
                path: "/platform/maintainTemplate"
            },
            {
                module_id: 43,
                module_name: "异常处理",
                path: "/platform/exceptionHandling"
            },
        ]
    },
    {
        module_id: 5,
        icon: "el-icon-files",
        index: "5",
        module_name: "代理商/药房",
        list: [
            {
                module_id: 51,
                module_name: "代理商",
                path: "/platform/operator"
            },
            {
                module_id: 52,
                module_name: "托管药房",
                path: "/platform/hostingPharmacy"
            },
        ]
    },
    {
        module_id: 6,
        icon: "el-icon-data-line",
        index: "6",
        module_name: "数据分析",
        list: [
            {
                module_id: 61,
                module_name: "设备销售量",
                path: "/recipeStatistics/salesChart"
            },   {
                module_id: 62,
                module_name: "设备分析",
                path: "/recipeStatistics/anomaly/anomaly"
            },  {
                module_id: 63,
                module_name: "耗材分析",
                path: "/recipeStatistics/consumables/cupsExpendChart"
            },{
                module_id: 64,
                module_name: "药品用量分析",
                path: "/recipeStatistics/drugDosage/operator"
            },{
                module_id: 65,
                module_name: "处方分析",
                path: "/recipeStatistics/prescriptionAnalysis/operator"
            },{
                module_id: 66,
                module_name: "药品库存分析",
                path: "/recipeStatistics/drugInventory/stocks"
            },{
                module_id: 67,
                module_name: "异常分析",
                path: "/recipeStatistics/abnormal/abnormal"
            },{
                module_id: 68,
                module_name: "满意度分析",
                path: "/recipeStatistics/satisfaction/service"
            },
            {
                module_id: 68,
                module_name: "药杯生产指导",
                path: "/recipeStatistics/cupProduction/cupProduction"
            },
        ]
    },
    {
        module_id: 7,
        icon: "el-icon-s-comment",
        index: "7",
        module_name: "公告管理",
        list: [
            {
                module_id: 71,
                module_name: "发布公告",
                path: "/notice/notice"
            },
        ]
    },
    {
        module_id: 8,
        icon: "el-icon-setting",
        index: "8",
        module_name: "系统设置",
        list: [
            {
                module_id: 71,
                module_name: "参数设置",
                path: "/setting/setting"
            },
        ]
    },
]